export const GET_LIST_DANHSACHKHACHHANG = "GET_LIST_DANHSACHKHACHHANG";
export const GET_LIST_DANHSACHKHACHHANG_SUCCESS =
  "GET_LIST_DANHSACHKHACHHANG_SUCCESS";
export const GET_LIST_DANHSACHKHACHHANG_FAILURE =
  "GET_LIST_DANHSACHKHACHHANG_FAILURE";
